/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Values: csob-form-exports=CsobFormExports, form-reports=FormReports, form-calculation-excel=FormCalculationExcel, form-data=FormData, company-logo=CompanyLogo, company-file-storage=CompanyFileStorage
 * @export
 * @enum {string}
 */

export enum UploadedFileFeature {
    CsobFormExports = 'csob-form-exports',
    FormReports = 'form-reports',
    FormCalculationExcel = 'form-calculation-excel',
    FormData = 'form-data',
    CompanyLogo = 'company-logo',
    CompanyFileStorage = 'company-file-storage'
}


